import React from 'react'
import Button from '../Button/Button'
import styles from './CompaniesTeaser.module.scss'

function CompaniesTeaser(props) {
  return (
    <div className={styles.teaserWrapper}>
      <div className={styles.teaser + ' container'}>
        <h1>{props.title}</h1>
        <div className={styles.teaserCnt}>
          <p>{props.subtitle}</p>
          <Button to={props.button.button_link}>{props.button.button_text}</Button>
        </div>
      </div>
    </div>
  )
}

export default CompaniesTeaser